import { FinancialStatus } from 'models/Order';

export enum PackageProviderName {
    FOXPOST = 'foxpost',
    MPL_DELIVERY = 'mpl_delivery',
    MPL_PACKAGE_POINT = 'mpl_package_point',
    MPL_MOL = 'mpl_mol',
    MPL_COOP = 'mpl_coop',
    MPL_MEDIAMARKT = 'mpl_mediamarkt',
    MPL_OFFICE = 'mpl_office',
    GLS = 'gls',
    GLS_GLOBAL = 'gls_global',
    PACKETA = 'packeta',
    DPD = 'dpd',
    SPRINTER = 'sprinter',
    TOURMIX = 'tourmix',
    FAN_COURIER = 'fan_courier',
    FAN_COURIER_INTERNATIONAL = 'fan_courier_international',
    BRING = 'bring',
    SAMEDAY = 'sameday',
    INPOST = 'inpost',
    POSTNORD = 'postnord',
    POSTASK = 'slovensk_po_ta',
    BPOST = 'bpost',
    CORREOS = 'correos',
    OMNIVA = 'omniva',
    CARGUS = 'cargus',
    POCZTA_POLSKA = 'poczta_polska',
    ONE_BY_ALLEGRO_WEDO = 'one_by_allegro_wedo',
    GLS_POLAND = 'gls_poland',
    DPD_POLAND = 'dpd_poland',
    ECONT = 'econt',
    ECONT_ROMANIA = 'econt_romania',
    DPD_GLOBAL = 'dpd_global',
    DPD_GREECE = 'dpd_greece',
    DPD_ITALY = 'dpd_italy',
    DPD_SLOVENIA = 'dpd_slovenia',
    DPD_GB = 'dpd_gb',
    DPD_LATVIA = 'dpd_latvia',
    DPD_PORTUGAL = 'dpd_portugal',
    DPD_SLOVAKIA = 'dpd_slovakia',
    DPD_BULGARIA = 'dpd_bulgaria',
    DPD_SWEDEN = 'dpd_sweden',
    DPD_GERMANY = 'dpd_germany',
    DPD_CZECH_REPUBLIC = 'dpd_czech_republic',
    DPD_LUXEMBOURG = 'dpd_luxembourg',
    DPD_SPAIN = 'dpd_spain',
    DPD_SWITZERLAND = 'dpd_switzerland',
    DPD_AUSTRIA = 'dpd_austria',
    DPD_BELGIUM = 'dpd_belgium',
    DPD_NETHERLANDS = 'dpd_netherlands',
    DPD_ROMANIA = 'dpd_romania',
    DPD_ESTONIA = 'dpd_estonia',
    DPD_FRANCE = 'dpd_france',
    DPD_LITHUANIA = 'dpd_lithuania',
    GLS_FI = 'gls_fi',
    GLS_IT = 'gls_it',
    GLS_BG = 'gls_bg',
    GLS_BE = 'gls_be',
    GLS_FR = 'gls_fr',
    GLS_NL = 'gls_nl',
    GLS_LU = 'gls_lu',
    GLS_DE = 'gls_de',
    GLS_ES = 'gls_es',
    GLS_PT = 'gls_pt',
    GLS_AT = 'gls_at',
    GLS_GR = 'gls_gr',
    GLS_DK = 'gls_dk',
    PAXY = 'paxy',
    TOPTRANS = 'toptrans',
    CESKA_POSTA = 'ceska_posta',
    EXPRESS_ONE = 'express_one',
    CITY_EXPRESS = 'city_express',
    POSTA_SRBIJE = 'posta_srbije',
    HRVATSKA_POSTA = 'hrvatska_posta',
    POST_LUXEMBOURG = 'post_luxembourg',
    CTT = 'ctt',
    OVERSEAS_EXPRESS = 'overseas_express',
    UNISEND = 'unisend',
    POSTA_BEZ_HRANIC = 'posta_bez_hranic',
    SENDCLOUD = 'sendcloud',
    SEVEN_SENDERS = 'seven_senders',
    BUDBEE = 'budbee',
    SPRING_GDS = 'spring_gds',
    SHIPPYPRO = 'shippypro',
    INSTABOX = 'instabox',
    HELTHJEM = 'helthjem',
    DB_SCHENKER = 'db_schenker',
    POSTI = 'posti',
    BAL_KOVNA = 'bal_kovna',
    BOX_NOW = 'box_now',
    DHL = 'dhl',
    ECOLET = 'ecolet',
    FEDEX = 'fedex',
    MATKAHUOLTO = 'matkahuolto',
    ORLEN_PACZKA = 'orlen_paczka',
    PPL = 'ppl',
    SPS_SLOVAK_PARCEL_SERVICE = 'sps_slovak_parcel_service',
    UPS = 'ups',
    VENIPAK = 'venipak',
    WOOT_ROMANIA = 'woot_romania',
    YBOX24 = 'ybox24',

    // Non-EU pickup point providers
    AUSTRALIA_POST = 'australia_post',
    HUBBED_PARCELPOINT = 'hubbed_parcelpoint',
    ARAMEX_AUSTRALIA = 'aramex_australia',
    COURIERS_PLEASE = 'couriers_please',
    SF_EXPRESS = 'sf_express',
    HONGKONG_POST = 'hongkong_post',
    ALFRED24 = 'alfred24',
    CAINIAO = 'cainiao',
    PICK = 'pick',
    SINGPOST = 'singpost',
    NINJA_VAN = 'ninja_van',
    SHOPEE_SPX = 'shopee_spx',
    HIVE_BOX = 'hive_box',
    JD_LOGISTICS = 'jd_logistics',
    CHINA_POST_EMS = 'china_post_ems',
    SEVEN_ELEVEN = 'seven_eleven',
    FAMILYMART = 'familymart',
    HI_LIFE = 'hi_life',
    OK_MART = 'ok_mart',
    CHUNGHWA_POST = 'chunghwa_post',
    PACKCITY_JAPAN = 'packcity_japan',
    YAMATO_TRANSPORT = 'yamato_transport',
    JAPAN_POST = 'japan_post',
    SAGAWA_EXPRESS = 'sagawa_express',
    GS25 = 'gs25',
    CUPOST = 'cupost',
    CJ_LOGISTICS = 'cj_logistics',
    KOREA_POST = 'korea_post',
    CHILEXPRESS = 'chilexpress',
    BLUE_EXPRESS = 'blue_express',
    STARKEN = 'starken',
    CORREOS_DE_CHILE = 'correos_de_chile',
    PICKIT = 'pickit',
    OCA = 'oca',
    CORREO_ARGENTINO = 'correo_argentino',
    ANDREANI = 'andreani',
    URBANO = 'urbano',
    ENVIOPACK = 'enviopack',
    JADLOG = 'jadlog',
    CORREIOS = 'correios',
    CLIQUE_RETIRE = 'clique_retire',
    PEGAKI = 'pegaki',
    COORDINADORA = 'coordinadora',
    SERVIENTREGA = 'servientrega',
    INTERRAPIDISIMO = 'interrapidisimo',
    PARGO = 'pargo',
    THE_COURIER_GUY = 'the_courier_guy',
    PAXI = 'paxi',
    BOB_GO = 'bob_go',
    POSTNET = 'postnet',
    CANADA_POST = 'canada_post',
    PUROLATOR = 'purolator',
    FEDEX_HOLD_AT_LOCATION = 'fedex_hold_at_location',
    AMAZON_LOCKER = 'amazon_locker',
    USPS = 'usps',
    // KVIKK = 'kvikk',

    // Underlying carriers offered through the Kvikk aggregator (not selectable as standalone providers).
    KVIKK_GLS = 'kvikk_gls',
    KVIKK_DPD = 'kvikk_dpd',
    KVIKK_PACKETA = 'kvikk_packeta',
    KVIKK_MPL = 'kvikk_mpl',
    // KVIKK_ALZABOX = 'kvikk_alzabox',
    // KVIKK_PARCEL_SHOP = 'kvikk_parcel_shop',
    // KVIKK_LOCKER = 'kvikk_locker',
    // KVIKK_SHOP = 'kvikk_shop',
    KVIKK_FOXPOST = 'kvikk_foxpost',
    // KVIKK_ZBOX = 'kvikk_zbox',
    // KVIKK_ZPONT = 'kvikk_zpont',
    // KVIKK_AUTOMATA = 'kvikk_automata',
    // KVIKK_POSTA = 'kvikk_posta',
    // KVIKK_POSTA_PONT = 'kvikk_posta_pont',
}

export const AVAILABLE_PROVIDERS: PackageProviderName[] = [
    PackageProviderName.MPL_PACKAGE_POINT,
    PackageProviderName.FOXPOST,
    PackageProviderName.GLS,
    PackageProviderName.GLS_GLOBAL,
    PackageProviderName.PACKETA,
    PackageProviderName.DPD,
    PackageProviderName.TOURMIX,
    PackageProviderName.FAN_COURIER,
    PackageProviderName.FAN_COURIER_INTERNATIONAL,
    PackageProviderName.BRING,
    PackageProviderName.SAMEDAY,
    PackageProviderName.INPOST,
    PackageProviderName.POSTNORD,
    PackageProviderName.POSTASK,
    PackageProviderName.BPOST,
    PackageProviderName.CORREOS,
    PackageProviderName.OMNIVA,
    PackageProviderName.CARGUS,
    PackageProviderName.POCZTA_POLSKA,
    PackageProviderName.ONE_BY_ALLEGRO_WEDO,
    PackageProviderName.GLS_POLAND,
    PackageProviderName.DPD_POLAND,
    PackageProviderName.ECONT,
    PackageProviderName.ECONT_ROMANIA,
    PackageProviderName.DPD_GLOBAL,
    PackageProviderName.DPD_GREECE,
    PackageProviderName.DPD_ITALY,
    PackageProviderName.DPD_SLOVENIA,
    PackageProviderName.DPD_GB,
    PackageProviderName.DPD_LATVIA,
    PackageProviderName.DPD_PORTUGAL,
    PackageProviderName.DPD_SLOVAKIA,
    PackageProviderName.DPD_BULGARIA,
    PackageProviderName.DPD_SWEDEN,
    PackageProviderName.DPD_GERMANY,
    PackageProviderName.DPD_CZECH_REPUBLIC,
    PackageProviderName.DPD_LUXEMBOURG,
    PackageProviderName.DPD_SPAIN,
    PackageProviderName.DPD_SWITZERLAND,
    PackageProviderName.DPD_AUSTRIA,
    PackageProviderName.DPD_BELGIUM,
    PackageProviderName.DPD_NETHERLANDS,
    PackageProviderName.DPD_ROMANIA,
    PackageProviderName.DPD_ESTONIA,
    PackageProviderName.DPD_FRANCE,
    PackageProviderName.DPD_LITHUANIA,
    PackageProviderName.GLS_FI,
    PackageProviderName.GLS_IT,
    PackageProviderName.GLS_BG,
    PackageProviderName.GLS_BE,
    PackageProviderName.GLS_FR,
    PackageProviderName.GLS_NL,
    PackageProviderName.GLS_LU,
    PackageProviderName.GLS_DE,
    PackageProviderName.GLS_ES,
    PackageProviderName.GLS_PT,
    PackageProviderName.GLS_AT,
    PackageProviderName.GLS_GR,
    PackageProviderName.GLS_DK,
    PackageProviderName.PAXY,
    PackageProviderName.TOPTRANS,
    PackageProviderName.CESKA_POSTA,
    PackageProviderName.EXPRESS_ONE,
    PackageProviderName.CITY_EXPRESS,
    PackageProviderName.POSTA_SRBIJE,
    PackageProviderName.HRVATSKA_POSTA,
    PackageProviderName.POST_LUXEMBOURG,
    PackageProviderName.CTT,
    PackageProviderName.OVERSEAS_EXPRESS,
    PackageProviderName.UNISEND,
    PackageProviderName.POSTA_BEZ_HRANIC,
    PackageProviderName.SENDCLOUD,
    PackageProviderName.SEVEN_SENDERS,
    PackageProviderName.BUDBEE,
    PackageProviderName.SPRING_GDS,
    PackageProviderName.SHIPPYPRO,
    PackageProviderName.INSTABOX,
    PackageProviderName.HELTHJEM,
    PackageProviderName.DB_SCHENKER,
    PackageProviderName.POSTI,
    PackageProviderName.BAL_KOVNA,
    PackageProviderName.BOX_NOW,
    PackageProviderName.DHL,
    PackageProviderName.ECOLET,
    PackageProviderName.FEDEX,
    PackageProviderName.MATKAHUOLTO,
    PackageProviderName.ORLEN_PACZKA,
    PackageProviderName.PPL,
    PackageProviderName.SPS_SLOVAK_PARCEL_SERVICE,
    PackageProviderName.UPS,
    PackageProviderName.VENIPAK,
    PackageProviderName.WOOT_ROMANIA,
    PackageProviderName.YBOX24,
    PackageProviderName.AUSTRALIA_POST,
    PackageProviderName.HUBBED_PARCELPOINT,
    PackageProviderName.ARAMEX_AUSTRALIA,
    PackageProviderName.COURIERS_PLEASE,
    PackageProviderName.SF_EXPRESS,
    PackageProviderName.HONGKONG_POST,
    PackageProviderName.ALFRED24,
    PackageProviderName.CAINIAO,
    PackageProviderName.PICK,
    PackageProviderName.SINGPOST,
    PackageProviderName.NINJA_VAN,
    PackageProviderName.SHOPEE_SPX,
    PackageProviderName.HIVE_BOX,
    PackageProviderName.JD_LOGISTICS,
    PackageProviderName.CHINA_POST_EMS,
    PackageProviderName.SEVEN_ELEVEN,
    PackageProviderName.FAMILYMART,
    PackageProviderName.HI_LIFE,
    PackageProviderName.OK_MART,
    PackageProviderName.CHUNGHWA_POST,
    PackageProviderName.PACKCITY_JAPAN,
    PackageProviderName.YAMATO_TRANSPORT,
    PackageProviderName.JAPAN_POST,
    PackageProviderName.SAGAWA_EXPRESS,
    PackageProviderName.GS25,
    PackageProviderName.CUPOST,
    PackageProviderName.CJ_LOGISTICS,
    PackageProviderName.KOREA_POST,
    PackageProviderName.CHILEXPRESS,
    PackageProviderName.BLUE_EXPRESS,
    PackageProviderName.STARKEN,
    PackageProviderName.CORREOS_DE_CHILE,
    PackageProviderName.PICKIT,
    PackageProviderName.OCA,
    PackageProviderName.CORREO_ARGENTINO,
    PackageProviderName.ANDREANI,
    PackageProviderName.URBANO,
    PackageProviderName.ENVIOPACK,
    PackageProviderName.JADLOG,
    PackageProviderName.CORREIOS,
    PackageProviderName.CLIQUE_RETIRE,
    PackageProviderName.PEGAKI,
    PackageProviderName.COORDINADORA,
    PackageProviderName.SERVIENTREGA,
    PackageProviderName.INTERRAPIDISIMO,
    PackageProviderName.PARGO,
    PackageProviderName.THE_COURIER_GUY,
    PackageProviderName.PAXI,
    PackageProviderName.BOB_GO,
    PackageProviderName.POSTNET,
    PackageProviderName.CANADA_POST,
    PackageProviderName.PUROLATOR,
    PackageProviderName.FEDEX_HOLD_AT_LOCATION,
    PackageProviderName.AMAZON_LOCKER,
    PackageProviderName.USPS,
    // PackageProviderName.KVIKK,
];

export enum Languages {
    english = 'english',
    hungarian = 'hungarian',
    romanian = 'romanian',
    german = 'german',
    spanish = 'spanish',
}

export enum SettingKey {
    default_language = 'default_language',
    foxpost_api_keys = 'foxpost_api_keys',
    mpl_api_keys = 'mpl_api_keys',
    gls_api_keys = 'gls_api_keys',
    packeta_api_keys = 'packeta_api_keys',
    dpd_api_keys = 'dpd_api_keys',
    tourmix_api_keys = 'tourmix_api_keys',
    dpd_package_weight = 'dpd_package_weight',
    zones_and_providers = 'zones_and_providers',
    shipping_methods = 'shipping_methods',
    mpl_package_size = 'mpl_package_size',
    mpl_package_weight = 'mpl_package_weight',
    mpl_label_type = 'mpl_label_type',
    mpl_delivery_time_mode = 'mpl_delivery_time_mode',
    mpl_package_sending_mode = 'mpl_package_sending_mode',
    foxpost_label_type = 'foxpost_label_type',
    foxpost_packeta_label_type = 'foxpost_packeta_label_type',
    foxpost_package_size = 'foxpost_package_size',
    gls_label_type = 'gls_label_type',
    packeta_label_type = 'packeta_label_type',
    dpd_label_type = 'dpd_label_type',
    sprinter_label_type = 'sprinter_label_type',
    sender_details = 'sender_details',
    sender_details_extra_mpl = 'sender_details_extra_mpl',
    map_design = 'map_design',
    cart_button_design = 'cart_button_design',
    home_delivery = 'home_delivery',
    cash_onelivery = 'cod',
    payment_method = 'payment_method',
    provider_to_country = 'provider_to_country',
    integration_mode = 'integration_mode',
    app_activated = 'app_activated',
    map_translations = 'map_translations',
    selected_languages = 'selected_languages',
    enabled_shipping_types = 'enabled_shipping_types',
    checkout_settings = 'checkout_settings',

    test_api_keys_mpl = 'test_api_keys_mpl',
    test_api_keys_foxpost = 'test_api_keys_foxpost',
    test_api_keys_gls = 'test_api_keys_gls',
    test_api_keys_packeta = 'test_api_keys_packeta',
    test_api_keys_sprinter = 'test_api_keys_sprinter',
    test_api_keys_tourmix = 'test_api_keys_tourmix',

    use_test_api_mpl = 'use_test_api_mpl',
    use_test_api_foxpost = 'use_test_api_foxpost',
    use_test_api_gls = 'use_test_api_gls',
    use_test_api_packeta = 'use_test_api_packeta',
    use_test_api_sprinter = 'use_test_api_sprinter',
    use_test_api_tourmix = 'use_test_api_tourmix',
    mapped_payment_methods = 'mapped_payment_methods',

    mpl_order_send_mode = 'mpl_order_send_mode',
    gls_order_send_mode = 'gls_order_send_mode',
    packeta_order_send_mode = 'packeta_order_send_mode',
    foxpost_order_send_mode = 'foxpost_order_send_mode',
    dpd_order_send_mode = 'dpd_order_send_mode',
    tourmix_order_send_mode = 'tourmix_order_send_mode',

    mpl_third_party_fulfillment = 'mpl_third_party_fulfillment',
    gls_third_party_fulfillment = 'gls_third_party_fulfillment',
    packeta_third_party_fulfillment = 'packeta_third_party_fulfillment',
    foxpost_third_party_fulfillment = 'foxpost_third_party_fulfillment',
    dpd_third_party_fulfillment = 'dpd_third_party_fulfillment',
    tourmix_third_party_fulfillment = 'tourmix_third_party_fulfillment',

    gls_customer_note = 'gls_order_customer_note_enabled',
    mpl_customer_note = 'mpl_order_customer_note_enabled',
    foxpost_customer_note = 'foxpost_order_customer_note_enabled',
    sprinter_customer_note = 'sprinter_order_customer_note_enabled',
    packeta_customer_note = 'packeta_order_customer_note_enabled',
    dpd_customer_note = 'dpd_order_customer_note_enabled',

    gls_bulk_print_pdf = 'gls_bulk_print_pdf',
    mpl_bulk_print_pdf = 'mpl_bulk_print_pdf',
    foxpost_bulk_print_pdf = 'foxpost_bulk_print_pdf',
    sprinter_bulk_print_pdf = 'sprinter_bulk_print_pdf',
    packeta_bulk_print_pdf = 'packeta_bulk_print_pdf',
    dpd_bulk_print_pdf = 'dpd_bulk_print_pdf',
    tourmix_bulk_print_pdf = 'tourmix_bulk_print_pdf',

    dpd_sms_notification = 'dpd_sms_notification',

    rates_to_payment_methods = 'rates_to_payment_methods',

    gls_extra_package_services = 'gls_extra_package_services',

    foxpost_order_number_on_label = 'foxpost_order_number_on_label',

    order_reference_gls = 'order_reference_gls',

    mpl_value_insurance = 'mpl_value_insurance',

    gls_auto_fulfill = 'gls_auto_fulfill',
    tourmix_auto_fulfill = 'tourmix_auto_fulfill',
    mpl_auto_fulfill = 'mpl_auto_fulfill',
    foxpost_auto_fulfill = 'foxpost_auto_fulfill',
    dpd_auto_fulfill = 'dpd_auto_fulfill',
    packeta_auto_fulfill = 'packeta_auto_fulfill',
}

export enum WizardStepName {
    choose_service_provider = 'choose_service_provider',
    shipping_zone_rate = 'shipping_zone_rate',
    integration_mode_step = 'integration_mode_step',
    summary = 'summary',
    app_extensions = 'app_extensions',
}

export const financialStatuses: FinancialStatus[] = [
    'pending',
    'authorized',
    'partially_paid',
    'paid',
    'partially_refunded',
    'refunded',
    'voided',
];

export const noPickupPointProviders: PackageProviderName[] = [PackageProviderName.TOURMIX];

export const LEGACY_PARCEL_CREATE_PROVIDERS = [
    PackageProviderName.MPL_PACKAGE_POINT,
    PackageProviderName.FOXPOST,
    PackageProviderName.PACKETA,
    PackageProviderName.TOURMIX,
];
